export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/381642428074"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[9000] group"
    >
      <div className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20ba5a] shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50 transition-all duration-300 hover:scale-110">
        <i className="ri-whatsapp-line text-white text-2xl"></i>
        {/* Pulse ring */}
        <span className="absolute inset-0 bg-[#25D366] opacity-40 animate-ping rounded-none" style={{ animationDuration: '2s' }}></span>
      </div>
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
        <div className="bg-zinc-900 border border-zinc-700 text-white text-xs font-semibold px-3 py-2">
          Pišite nam na WhatsApp
        </div>
      </div>
    </a>
  );
}
